import React from "react";
import logo from "../../static/logo-ff.png";
import { ModalType } from "../modal/LeadModal";
import { NavLinks } from "./NavLinks";
import { HeaderActions } from "./HeaderActions";
import { useAuth } from "../../context/AuthContext";
import { NavLink } from "react-router-dom";

type Props = {
    onOpenModal: (type: ModalType) => void;
    onOpenMobileMenu: () => void;
    isMobileMenuOpen?: boolean;
};

export const Header: React.FC<Props> = ({
                                            onOpenModal,
                                            onOpenMobileMenu,
                                            isMobileMenuOpen = false,
                                        }) => {
    const { loading } = useAuth();
    const canShowAuthButtons = !loading;

    return (
        <header className="site-header">
            <div className="site-header-inner">
                <NavLink to="/" className="site-logo" aria-label="На главную">
                    <img src={logo} alt="FulfilWeb" className="site-logo-img" />
                </NavLink>

                <nav className="site-nav" aria-label="Основная навигация">
                    <NavLinks variant="desktop" />
                </nav>

                <HeaderActions canShowAuthButtons={canShowAuthButtons} onOpenModal={onOpenModal} />

                <button
                    className="header-burger"
                    type="button"
                    onClick={onOpenMobileMenu}
                    aria-label={isMobileMenuOpen ? "Закрыть меню" : "Открыть меню"}
                    aria-expanded={isMobileMenuOpen}
                    aria-controls="mobile-menu"
                >
                    <span className="header-burger-icon" aria-hidden="true">≡</span>
                </button>
            </div>
        </header>
    );
};
